import React, { useEffect, useState } from 'react';
import Dynamic_PR_table from '../../../../components/Dynamic_PR_table';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';
import { DeleteServiceCaller, GetServiceCaller } from '../../../../services/serviceCaller';
import { API_URL } from '../../../../constants';
import { logDOM } from '@testing-library/react';
import DeleteModal from '../../../../components/DeletePopUpComponent';
import { toast } from 'react-toastify';


const ModelMasters = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(updateNavbarHeading("Model Master"));
  }, [])

  const [searchTerm, setSearchTerm] = useState("");
  const [modelMaster, setModelMasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const columns = {
    CategoryName: { text: "Category", align: "left", visible: true },
    BrandName: { text: "Make", align: "left", visible: true },
    ModelName: { text: "Model", align: "left", visible: true },
    Remark: { text: "Remark", align: "left", visible: true },
    IsInActive: { text: "Active", align: "center",width:"60px", visible: true },

  }

  useEffect(() => {
    fetchModelMasters();
  }, [])
 const [apiStatus, SetApiStatus] = useState(undefined);
  const fetchModelMasters = async () => {
    const response = await GetServiceCaller(`${API_URL}model-masters`);
    SetApiStatus(response?.status);
    if (response.status === 200) {
      const fetchData = response?.data?.data;
      setModelMasters(fetchData);
      setLoading(false);
    }
    else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  }

  const handleEdit = (id) => {
    navigate(`/model-master/edit/${id.ID}`)
  }
  const handleAddNewModelMasters = () => {
    navigate(`/model-master/add`)
  }

  const handleDelete = (item) => {
    setSelectedDeleteItem(item);
    setShowDeleteModal(true)

  }
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      {
        handleDeleteLine(selectedDeleteItem.index, selectedDeleteItem.ID);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);

    }
  };


  const handleDeleteLine = async (index, ID,) => {
    if (ID) {  // Checks if PocID is truthy (not null, undefined, or empty)
      try {
     const response =    await DeleteServiceCaller(
          `${API_URL}model-masters/${ID}`,
          {},
          "delete"
        );        
        fetchModelMasters()
        if(response?.status === 200){
          toast.success("Data Deleted successfully");
        }
      } catch (error) {
        console.error("There was an error deleting the Row!", error);
      }
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
          <Dynamic_PR_table
            data={modelMaster}
            columns={columns}
            itemsPerPage={8}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            showIcon1={true}
            showIcon2={false}
            showIcon3={false}
            showIcon4={false}
            showIcon5={false}
            isSorting={true}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            handleIcon1={handleEdit}
            // handleIcon2={handleDelete}
            handleAddNew={handleAddNewModelMasters}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square icons"></i>,
              Icon1Text: " Edit",
              // Icon2: <i className="bi bi-trash" style={{ fontSize: "1.2rem" }} ></i>,
              // Icon2Text: " Delete",
            }}
          />
        </div>
        </div>
        {/** Delete PopUP  */}

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete the  Model?"
        />
      </div>
    </>
  )
}

export default ModelMasters